export default "__VITE_ASSET__ab01f061__"